module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Armless Wedge Sofa_Sand.ac241b02.png";